import type {
  HierarchyAssignment,
  HierarchyEntityType,
  HierarchyRelationType,
} from '../types/domain';

export function getActiveSectors(
  entityType: HierarchyEntityType,
  entityId: string,
  history: HierarchyAssignment[],
): string[] {
  return history
    .filter((h) =>
      h.entityType === entityType
      && h.entityId === entityId
      && h.relationType === 'sector'
      && h.endDate === null)
    .map((h) => h.relationId);
}

export function getActiveSupervisors(
  operatorId: string,
  history: HierarchyAssignment[],
): string[] {
  return history
    .filter((h) =>
      h.entityType === 'operator'
      && h.entityId === operatorId
      && h.relationType === 'supervisor'
      && h.endDate === null)
    .map((h) => h.relationId);
}

export function getEntityHistory(
  entityType: HierarchyEntityType,
  entityId: string,
  history: HierarchyAssignment[],
): HierarchyAssignment[] {
  return history
    .filter((h) => h.entityType === entityType && h.entityId === entityId)
    .sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
}

export function getHierarchyAtDate(
  entityType: HierarchyEntityType,
  entityId: string,
  date: string | Date,
  history: HierarchyAssignment[],
): { sectors: string[]; supervisors: string[] } {
  const targetDate = new Date(date).getTime();
  const activeAtDate = history.filter((h) => {
    if (h.entityType !== entityType || h.entityId !== entityId) return false;
    const start = new Date(h.startDate).getTime();
    const end = h.endDate ? new Date(h.endDate).getTime() : Infinity;
    return targetDate >= start && targetDate <= end;
  });

  return {
    sectors: activeAtDate.filter((h) => h.relationType === 'sector').map((h) => h.relationId),
    supervisors: activeAtDate.filter((h) => h.relationType === 'supervisor').map((h) => h.relationId),
  };
}

export function createAssignment(
  entityType: HierarchyEntityType,
  entityId: string,
  relationType: HierarchyRelationType,
  relationId: string,
  reason: string,
  createdBy: string,
  startDate: string = new Date().toISOString(),
): Omit<HierarchyAssignment, 'id'> {
  return {
    entityType,
    entityId,
    relationType,
    relationId,
    startDate,
    endDate: null,
    reason,
    createdBy,
  };
}

export function endAssignment(
  assignment: HierarchyAssignment,
  reason: string,
  endDate: string = new Date().toISOString(),
): HierarchyAssignment {
  return {
    ...assignment,
    endDate,
    reason: assignment.reason
      ? `${assignment.reason} -> Encerrado: ${reason}`
      : `Encerrado: ${reason}`,
  };
}
